/**
 * Synced from convex/lib/productFeedbackConstants.ts (universal feedback wire contract).
 */

export const PRODUCT_FEEDBACK_SURFACES = ['cli', 'mcp', 'cortex', 'api', 'website'] as const;
export const PRODUCT_FEEDBACK_ACTORS = ['human', 'agent', 'human-via-agent'] as const;
export const PRODUCT_FEEDBACK_CATEGORIES = ['bug', 'friction', 'idea', 'praise', 'other'] as const;
export const PRODUCT_FEEDBACK_STATUSES = ['new', 'triaged', 'planned', 'resolved', 'dismissed'] as const;

export type ProductFeedbackSurface = (typeof PRODUCT_FEEDBACK_SURFACES)[number];
export type ProductFeedbackActor = (typeof PRODUCT_FEEDBACK_ACTORS)[number];
export type ProductFeedbackCategory = (typeof PRODUCT_FEEDBACK_CATEGORIES)[number];
export type ProductFeedbackStatus = (typeof PRODUCT_FEEDBACK_STATUSES)[number];
